export default {
  ENVIRONMENT: process.env.VUE_APP_TARGET_ENVIRONMENT,
  API_URL: process.env.VUE_APP_API_URL,
  RESET_PASSWORD_URL: process.env.VUE_APP_PASSWORD_API_URL,
  SECRET: "/secret",
  BROADCAST_CHANNELS: "/notification/broadcast/channels/me",
  BROADCAST_HISTORY: "/notification/broadcast/me",
  FIREBASE_SUBSCRIBE: "/notification/subscribe",
  FIREBASE_UNSUBSCRIBE: "/notification/unsubscribe",
};
